import { TableFilterModel } from '@/Types/TableFilterModel';

const defaultSize = 50;

function getTableFilterState<T>(stateKey: string): TableFilterModel<T> {
  const state = localStorage.getItem(stateKey);

  if (!state) {
    return {
      currentPage: 0,
      pageSize: defaultSize,
    };
  }

  return formatTableFilterState(JSON.parse(state));
}

function formatTableFilterState<T>(state: any): TableFilterModel<T> {
  const { columns, pageIndex, pageSize } = state;

  const tableConfig = {
    currentPage: pageIndex,
    pageSize: pageSize || defaultSize,
  };

  const sortedFieldIdx = columns.findIndex((item: any) => item.sortOrder);

  if (sortedFieldIdx != -1) {
    return {
      sortColumn: columns[sortedFieldIdx].name,
      sortType: columns[sortedFieldIdx].sortOrder,
      ...tableConfig,
    };
  }

  return tableConfig;
}

export const tableUtils = {
  getTableFilterState,
  formatTableFilterState,
};
